import React from 'react';

import classNames from 'classnames';

import styles from './HomeSection.module.scss';

function HomeSection({ title, subtitle, containerClassName, className, children, ...props }) {
  return (
    <section className={containerClassName} data-testid="home-section" {...props}>
      <div className={styles.wrapper} data-testid="home-section-wrapper">
        <div className={styles.headingContainer}>
          <span className={styles.title}>{title}</span>
          <div className={styles.subtitle}>{subtitle}</div>
        </div>

        <div className={classNames(styles.contentContainer, className)} data-testid="home-section-content">
          {children}
        </div>
      </div>
    </section>
  );
}

export default HomeSection;
